import type { MarkdownSkin } from "./Markdown";

export type MarkdownEditorTheme = {
  label: string;
  toolbar: string;
  toolbarButton: string;
  modeGroup: string;
  modeActive: string;
  modeInactive: string;
  field: string;
  fieldFocus: string;
  fieldBorder: string;
  fieldErrorBorder: string;
  preview: string;
  previewEmpty: string;
  livePreview: string;
  livePreviewLabel: string;
  error: string;
  popup: string;
  popupEmpty: string;
  popupActive: string;
  popupInactive: string;
  popupLabel: string;
  popupTitle: string;
  markdown?: MarkdownSkin;
};

export const DEFAULT_MARKDOWN_EDITOR_THEME: MarkdownEditorTheme = {
  label: "block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1",
  toolbar: "border-neutral-300 dark:border-neutral-600 rounded-t-lg bg-neutral-50 dark:bg-neutral-800/60",
  toolbarButton:
    "rounded text-neutral-500 dark:text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700",
  modeGroup: "rounded-lg border border-neutral-300 dark:border-neutral-600",
  modeActive: "bg-emerald-500 text-white",
  modeInactive: "bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700",
  field:
    "rounded-b-lg rounded-tr-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-500 disabled:bg-neutral-100 dark:disabled:bg-neutral-700",
  fieldFocus: "focus:ring-emerald-500 focus:border-emerald-500",
  fieldBorder: "border-neutral-300 dark:border-neutral-600",
  fieldErrorBorder: "border-red-500 focus:ring-red-500 focus:border-red-500",
  preview: "rounded-b-lg rounded-tr-lg border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800",
  previewEmpty: "text-sm text-neutral-400 dark:text-neutral-500",
  livePreview: "rounded-lg border border-dashed border-neutral-300 dark:border-neutral-600",
  livePreviewLabel: "text-xs font-medium uppercase tracking-wide text-neutral-400 dark:text-neutral-500",
  error: "mt-1 text-sm text-red-600",
  popup: "rounded-lg border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 shadow-lg",
  popupEmpty: "px-3 py-2 text-sm text-neutral-500 dark:text-neutral-400",
  popupActive: "bg-emerald-50 dark:bg-emerald-900/30",
  popupInactive: "hover:bg-neutral-100 dark:hover:bg-neutral-700",
  popupLabel: "block truncate text-sm text-neutral-900 dark:text-neutral-100",
  popupTitle: "block truncate text-xs text-neutral-500 dark:text-neutral-400",
};

export const resolveMarkdownEditorTheme = (overrides?: Partial<MarkdownEditorTheme>): MarkdownEditorTheme =>
  overrides ? { ...DEFAULT_MARKDOWN_EDITOR_THEME, ...overrides } : DEFAULT_MARKDOWN_EDITOR_THEME;
